import { isAction, type Middleware } from 'redux';
import { type RootState } from '../state/store';
import { type Event, initialState as initialOrchestratorState } from '../slices/local/orchestrator';

const LS_STATE_KEY = 'hydrated-state';
const LS_ACTION_TYPES = [
  'orchestrator/playItem',
  'orchestrator/rateItem'
];
// const LS_MAX_STATION_EVENTS = 65536; // @todo

interface DehydratedState {
  stationEvents: Record<number, Event[]>
  songEvents: Record<number, Event[]>
}

const hydrate = (): RootState => {
  let state = {};
  const stateStr = window.localStorage.getItem(LS_STATE_KEY);
  if (stateStr !== null) {
    try {
      const {
        stationEvents,
        songEvents
      } = JSON.parse(stateStr) as DehydratedState;

      // Reconstruct initial application state
      state = {
        orchestrator: {
          ...initialOrchestratorState,
          stationEvents: stationEvents || {},
          songEvents: songEvents || {}
        }
      };

      console.info('Hydrated application state', state);
    } catch (e) {
      /* Whatever happens here, better ignore it... ^^^ */
    }
  }

  return state as RootState;
};

const dehydrate = (state: RootState): DehydratedState => {
  return {
    stationEvents: state.orchestrator.stationEvents,
    songEvents: state.orchestrator.songEvents
  };
};

const dehydrationMiddleware: Middleware<unknown, RootState> = ({ getState }) => {
  return next => action => {
    if(isAction(action)) {
      const result = next(action);

      if(LS_ACTION_TYPES.includes(action.type)) {
        const appState = getState();
        const dehydratedState = dehydrate(appState);

        window.localStorage.setItem(LS_STATE_KEY, JSON.stringify(dehydratedState));
      }

      return result;
    } 
    
    return next(action);
  }
};

export {
  hydrate,
  dehydrationMiddleware
};
